import AuthlessA5PrintPage from "@/components/common-receipt/AuthlessA5PrintPage";
import { rentReceiptA5Props, type RentReceiptPrintRecord } from "./rent-receipt-print-content";

const RentReceiptPrint = () => (
  <AuthlessA5PrintPage<RentReceiptPrintRecord> location="contRcpt" toProps={rentReceiptA5Props} />
);

export default RentReceiptPrint;
